import { ValidationErrors } from 'final-form';

interface IDirtyField {
  [key: string]: boolean;
}

export const shouldDisplayError = (
  field: string | null | undefined,
  errors?: ValidationErrors,
  dirtyFields?: IDirtyField,
) => {
  return errors?.[field as string] && dirtyFields?.[field as string];
};
